import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Label,
  Modal,
  Row
} from "reactstrap";
import React, { Fragment, useEffect, useState } from "react";
import {
  ADMIN_FILTER,
  CLIENT_FILTER,
  LM_INVENTORY,
  DAILY_DELIVERY_REPORT_FILTER,
  ASSIGNED_TO_AIDUK_LM,
  DELIVERED_FILTER,
  CLIENT_PICKUP_REQUEST_FILTER,
  CLIENT_PICKUP_REQUEST_ADMIN_FILTER,
  DELIVERY_RUN_SHEET_FILTER
} from "constants/filter-type.constant";
import { getHubs } from "reducers/Hubs";
import DatePicker from "react-datepicker";
import { getCities } from "reducers/Cities";

import DateUtil from "../../utils/dateUtil";
import { selectTheme } from "constants/index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select";
import { connect } from "react-redux";
import { get3PLS } from "reducers/TPLPartner";
import { getClients } from "reducers/Clients";
import { getEmployees } from "reducers/Employees";
import { getOrderStatuses } from "reducers/order";
import { shipingList } from "reducers/Shipments";
import { getServiceTypes } from "reducers/ServiceTypes";
import { CREATED, ASSIGNED, CLOSED, FAILED } from "constants/pickup-request-status.constant";
import { CLIENT_ROLE } from "constants/role.constant";

const PICKUP_REQUEST_OPTIONS = [
  {
    label: CREATED,
    value: CREATED
  }, {
    label: ASSIGNED,
    value: ASSIGNED
  }, {
    label: CLOSED,
    value: CLOSED
  }, {
    label: FAILED,
    value: FAILED
  }
];

const PAYMENT_MODE_OPTIONS = [
  { value: "COD", label: "COD" },
  { value: "PPD", label: "PPD" },
];

const columnStyle = {
  paddingTop: 10,
  paddingBottom: 10
};

const FilterComponent = ({
  filterType = "",
  show = false,
  onToggle = () => { },
  handleFilter = () => { },
  clearFilter = false,
  getClients,
  get3PLS,
  getServiceTypes,
  getOrderStatuses,
  getHubs,
  getCities,
  getEmployees
}) => {
  // common function to get value from localstoreage
  // const getStoredValue = (key) => JSON.parse(localStorage.getItem(key));

  const [isClient, setIsClient] = useState(true);

  // Dropdown values
  const [clientList, setClientList] = useState([]);
  const [tplList, set3PLList] = useState([]);
  const [serviceTypeList, setServiceTypeList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [hubList, setHubList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);

  // Selected values
  const [hub, setHub] = useState([]);
  const [city, setCity] = useState([]);
  const [status, setStatus] = useState([]);
  const [clientId, setClientId] = useState([]);
  const [tplId, setTPLId] = useState([]);
  const [employee, setEmployee] = useState([]);
  const [pickupStatus, setPickupStatus] = useState([]);
  const [paymentMode, setPaymentMode] = useState([]);
  const [serviceType, setServiceType] = useState([]);
  const [dateLabel, setDateLabel] = useState("Date");
  const [employeeLabel, setEmployeeLabel] = useState("Employee");

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [createdStartDate, setCreatedStartDate] = useState(null);
  const [createdEndDate, setCreatedEndDate] = useState(null);
  const [pickupStartDate, setPickupStartDate] = useState(null);
  const [pickupEndDate, setPickupEndDate] = useState(null);
  const [deliveryStartDate, setDeliveryStartDate] = useState(null);
  const [deliveryEndDate, setDeliveryEndDate] = useState(null);
  const [formField, setFormField] = useState(null);

  /**
   * Fetch all city list
   */
  const getAllCity = async () => {
    const res = await getCities();
    const list = res.map(({ code, name }) => ({
      label: name,
      value: code
    }));
    setCityList(list);
  };

  /**
   * Fetch all employee list
   */
  const getAllEmployee = async () => {
    const res = await getEmployees();
    const list = res.map(({ name, id }) => ({
      label: name,
      value: id
    }));
    setEmployeeList(list);
  };

  /**
   * Fetch all hub list
   */
  const getAllHub = async () => {
    const res = await getHubs();
    const list = res.map(({ name, code }) => ({
      label: name,
      value: code
    }));
    setHubList(list);
  };

  /**
   * Fetch order status
   */
  const getAllOrderStatus = async () => {
    const res = await getOrderStatuses();
    const list = res.map((option) => ({
      label: option.status,
      value: option.code
    }));
    setStatusList(list);
  };

  /**
   * Fetch service types
   */
  const getAllServiceTypes = async () => {
    const res = await getServiceTypes();
    const list = res.map((option) => ({
      label: option.name,
      value: option.code
    }));
    setServiceTypeList(list);
  };

  /**
   * Fetch all clients
   */
  const getAllClients = async () => {
    const res = await getClients();
    const list = res.map((option) => ({
      label: option.name,
      value: option.id
    }));
    setClientList(list);
  };

  /**
   * Fetch all 3PL's
   */
  const getAll3PL = async () => {
    const res = await get3PLS();
    let list = res.map((option) => ({
      label: option.name,
      value: option.id
    }));
    list.unshift({
      label: "null",
      value: null
    });
    set3PLList(list);
  };

  /**
   * Get values from dropdown values
   * @param {*} records
   */
  const getValues = (records) => {
    if (!records) {
      return [];
    }
    return records.map((item) => item.value);
  };

  // common function to store value to localstorage
  // const storeValue = (key, value) => {
  //   localStorage.setItem(key, JSON.stringify(value));
  // };

  /**
   * On click of apply filter
   */
  const onApplyFilter = () => {
    // REVERT: for not revert persist filter
    // storeValue('clientId', clientId);
    // storeValue('tplId', tplId);
    // storeValue('serviceType', serviceType);
    // storeValue('status', status);

    // Generate filter data
    let filter = {
      clientId: getValues(clientId),
      tplId: getValues(tplId),
      serviceType: getValues(serviceType),
      status: getValues(status),
      hub: getValues(hub),
      pickupStatus: getValues(pickupStatus),
      employeeId: getValues(employee),
      destCityCode: getValues(city),
      paymentMode: getValues(paymentMode)
    };

    // Check for date
    if (startDate && endDate) {
      if (startDate > endDate) {
        alert("Please select start date less than end date");
        return;
      }

      filter.date = {
        from: DateUtil.format(startDate),
        to: DateUtil.format(endDate)
      };
    }

    // Check for created date
    if (createdStartDate && createdEndDate) {
      if (createdStartDate > createdEndDate) {
        alert("Please select start date less than end date");
        return;
      }

      filter.orderInitTime = {
        from: DateUtil.format(createdStartDate),
        to: DateUtil.format(createdEndDate)
      };
    }

    // Check for pickup date
    if (pickupStartDate && pickupEndDate) {
      if (pickupStartDate > pickupEndDate) {
        alert("Please select start date less than end date");
        return;
      }

      filter.pickupDate = {
        from: DateUtil.format(pickupStartDate),
        to: DateUtil.format(pickupEndDate)
      };
    }

    // Check for delivery date
    if (deliveryStartDate && deliveryEndDate) {
      if (deliveryStartDate > deliveryEndDate) {
        alert("Please select start date less than end date");
        return;
      }

      filter.deliveryDate = {
        from: DateUtil.format(deliveryStartDate),
        to: DateUtil.format(deliveryEndDate)
      };
    }

    // Apply filter (callback)
    handleFilter(filter);

    // Hide modal
    onToggle();
  };

  /**
   * Clear form data
   */
  const clearData = () => {
    setHub([]);
    setCity([]);
    setStatus([]);
    setClientId([]);
    setTPLId([]);
    setServiceType([]);
    setStatus([]);
    setEmployee([]);
    setStartDate(null);
    setEndDate(null);
    setCreatedStartDate(null);
    setCreatedEndDate(null);
    setPickupStartDate(null);
    setPickupEndDate(null);
    setDeliveryStartDate(null);
    setDeliveryEndDate(null);
  };

  const fetchData = () => {
    // Check user role
    const userRole = localStorage.getItem("role");
    if (userRole && userRole.toUpperCase() !== CLIENT_ROLE) {
      setIsClient(false);
      // If user is Admin or employee, then fetch 3PL and clients
      getAll3PL();
      getAllClients();
      getAllCity();
      getAllEmployee();
    }

    getAllHub();
    getAllOrderStatus();
    getAllServiceTypes();
  };

  // On load fetch dropdown data/options
  useEffect(() => {
    // Wait to avoid multiple API call which delay order table API
    setTimeout(() => fetchData(), 4000);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // On load fetch dropdown data/options
  useEffect(() => {
    clearData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearFilter]);

  useEffect(() => {
    let isDateHidden = true;
    let isClientHidden = true;
    let isServiceTypeHidden = true;
    let is3PLHidden = true;
    let isStatusHidden = true;
    let isEmployeeHidden = true;
    let isOrderCreatedDateHidden = true;
    let isPickUpDateHidden = true;
    let isDestinationCityHidden = true;
    let isHubSelectionHidden = true;
    let isOrderDeliveryDateHidden = true;
    let isPickupStatusHidden = true;
    let isPaymentModeHidden = true;

    switch (filterType) {
      case ADMIN_FILTER:
        isClientHidden = false;
        isServiceTypeHidden = false;
        is3PLHidden = false;
        isStatusHidden = false;
        isPickUpDateHidden = false;
        isOrderCreatedDateHidden = false;
        isPaymentModeHidden = false;
        isDestinationCityHidden = false;
        break;
      case CLIENT_FILTER:
        isClientHidden = false;
        isServiceTypeHidden = false;
        is3PLHidden = false;
        isStatusHidden = false;
        isPickUpDateHidden = false;
        isOrderCreatedDateHidden = false;
        break;
      case LM_INVENTORY:
        isClientHidden = false;
        isDestinationCityHidden = false;
        // isHubSelectionHidden = false;
        break;
      case DAILY_DELIVERY_REPORT_FILTER:
        isOrderDeliveryDateHidden = false;
        break;
      case ASSIGNED_TO_AIDUK_LM:
        isClientHidden = false;
        isServiceTypeHidden = false;
        is3PLHidden = false;
        isStatusHidden = false;
        isPickUpDateHidden = false;
        isDestinationCityHidden = false;
        isHubSelectionHidden = false;
        isOrderCreatedDateHidden = false;
        break;
      case DELIVERED_FILTER:
        isClientHidden = false;
        isServiceTypeHidden = false;
        is3PLHidden = false;
        isDestinationCityHidden = false;
        isHubSelectionHidden = false;
        isOrderDeliveryDateHidden = false;
        break;
      case DELIVERY_RUN_SHEET_FILTER:
        isHubSelectionHidden = false;
        isDateHidden = false;
        isEmployeeHidden = false;
        isPickupStatusHidden = false;
        setDateLabel("Date");
        setEmployeeLabel("Driver");
        break;
      case CLIENT_PICKUP_REQUEST_FILTER:
        isDateHidden = false;
        isPickupStatusHidden = false;
        setDateLabel("Date");
        break;
      case CLIENT_PICKUP_REQUEST_ADMIN_FILTER:
        isClientHidden = false;
        isDateHidden = false;
        isEmployeeHidden = false;
        isPickupStatusHidden = false;
        setDateLabel("Date");
        break;
      default:
        break;
    }

    setFormField({
      isDateHidden,
      isClientHidden,
      isServiceTypeHidden,
      is3PLHidden,
      isStatusHidden,
      isEmployeeHidden,
      isOrderCreatedDateHidden,
      isPickUpDateHidden,
      isPaymentModeHidden,
      isDestinationCityHidden,
      isHubSelectionHidden,
      isOrderDeliveryDateHidden,
      isPickupStatusHidden
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterType]);

  // On load fetch filters applied
  // useEffect(() => {
  //   const appliedFilter = JSON.parse(localStorage.getItem('orderFilter'));
  //   if (appliedFilter) {
  //     if (appliedFilter.status.length) {
  //       setStatus(getStoredValue('status'));
  //     }
  //     if (appliedFilter.tplId.length) {
  //       setTPLId(getStoredValue('tplId'));
  //     }
  //     if (appliedFilter.serviceType.length) {
  //       setServiceType(getStoredValue('serviceType'));
  //     }
  //     if (appliedFilter.clientId.length) {
  //       setClientId(getStoredValue('clientId'));
  //     }
  //     if (appliedFilter.orderInitTime) {
  //       setCreatedStartDate(new Date(appliedFilter.orderInitTime.from));
  //       setCreatedEndDate(new Date(appliedFilter.orderInitTime.to));
  //     }
  //     if (appliedFilter.pickupDate) {
  //       setPickupStartDate(new Date(appliedFilter.pickupDate.from));
  //       setPickupEndDate(new Date(appliedFilter.pickupDate.to));
  //     }
  //   }
  // }, []);

  return (
    <Fragment>
      <Modal
        zIndex={2000}
        centered
        size="xl"
        isOpen={show}
        toggle={onToggle}
        contentClassName="modal-example-1 border-0 bg-transparent">
        <Card className="card-box mb-4">
          <CardBody>
            <div style={{ padding: 10 }}>
              <Row>
                {/* Client Picker */}
                {!isClient && (
                  <Col
                    md="6"
                    lg="6"
                    style={columnStyle}
                    hidden={formField?.isClientHidden}>
                    <div className="heading-3">Client</div>
                    <Select
                      isSearchable
                      isMulti
                      placeholder="Select client..."
                      value={clientId}
                      onChange={setClientId}
                      options={clientList}
                      theme={(theme) => selectTheme(theme)}
                    />
                  </Col>
                )}
                {/* Service Type */}
                <Col
                  md="6"
                  lg="6"
                  style={columnStyle}
                  hidden={formField?.isServiceTypeHidden}>
                  <div className="heading-3">Service Type</div>
                  <Select
                    isSearchable
                    isMulti
                    placeholder="Select service type..."
                    value={serviceType}
                    onChange={setServiceType}
                    options={serviceTypeList}
                    theme={(theme) => selectTheme(theme)}
                  />
                </Col>
                {/* 3PL */}
                {!isClient && (
                  <Col
                    md="6"
                    lg="6"
                    style={columnStyle}
                    hidden={formField?.is3PLHidden}>
                    <div className="heading-3">3PL</div>
                    <Select
                      isSearchable
                      isMulti
                      placeholder="Select 3PL..."
                      value={tplId}
                      onChange={setTPLId}
                      options={tplList}
                      theme={(theme) => selectTheme(theme)}
                    />
                  </Col>
                )}

                {/* Status */}
                <Col
                  md="6"
                  lg="6"
                  style={columnStyle}
                  hidden={formField?.isStatusHidden}>
                  <div className="heading-3">Status</div>
                  <Select
                    isSearchable
                    isMulti
                    placeholder="Select status..."
                    defaultValue={status}
                    onChange={setStatus}
                    options={statusList}
                    theme={(theme) => selectTheme(theme)}
                  />
                </Col>

                {/* Employee */}
                <Col
                  md="6"
                  lg="6"
                  style={columnStyle}
                  hidden={formField?.isEmployeeHidden}>
                  <div className="heading-3">{employeeLabel}</div>
                  <Select
                    isSearchable
                    isMulti
                    placeholder={`Select ${employeeLabel}...`}
                    defaultValue={employee}
                    onChange={setEmployee}
                    options={employeeList}
                    theme={(theme) => selectTheme(theme)}
                  />
                </Col>

                {/* Destination City */}
                <Col
                  md="6"
                  lg="6"
                  style={columnStyle}
                  hidden={formField?.isDestinationCityHidden}>
                  <div className="heading-3">Destination City</div>
                  <Select
                    isSearchable
                    isMulti
                    placeholder="Select City..."
                    defaultValue={city}
                    onChange={setCity}
                    options={cityList}
                    theme={(theme) => selectTheme(theme)}
                  />
                </Col>

                {/* Hub */}
                <Col
                  md="6"
                  lg="6"
                  style={columnStyle}
                  hidden={formField?.isHubSelectionHidden}>
                  <div className="heading-3">Hub</div>
                  <Select
                    isSearchable
                    isMulti
                    placeholder="Select Hub..."
                    defaultValue={hub}
                    onChange={setHub}
                    options={hubList}
                    theme={(theme) => selectTheme(theme)}
                  />
                </Col>

                {/* Pickup Request Status */}
                <Col
                  md="6"
                  lg="6"
                  style={columnStyle}
                  hidden={formField?.isPickupStatusHidden}>
                  <div className="heading-3">Status</div>
                  <Select
                    isSearchable
                    isMulti
                    placeholder="Select Status..."
                    defaultValue={pickupStatus}
                    onChange={setPickupStatus}
                    options={PICKUP_REQUEST_OPTIONS}
                    theme={(theme) => selectTheme(theme)}
                  />
                </Col>

                {/* Payment Mode */}
                <Col
                  md="6"
                  lg="6"
                  style={columnStyle}
                  hidden={formField?.isPaymentModeHidden}>
                  <div className="heading-3">Payment Mode</div>
                  <Select
                    isSearchable
                    isMulti
                    placeholder="Select Payment Mode..."
                    defaultValue={paymentMode}
                    onChange={setPaymentMode}
                    options={PAYMENT_MODE_OPTIONS}
                    theme={(theme) => selectTheme(theme)}
                  />
                </Col>

                {/* Date Field */}
                <Col
                  md="6"
                  lg="6"
                  style={columnStyle}
                  hidden={formField?.isDateHidden}>
                  <div className="heading-3">{dateLabel}</div>
                  <Row>
                    <Col md="12">
                      <FormGroup>
                        <Label>From date:</Label>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <FontAwesomeIcon icon={["far", "calendar-alt"]} />
                            </InputGroupText>
                          </InputGroupAddon>
                          <DatePicker
                            className="form-control"
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            selectsStart
                            startDate={startDate}
                            endDate={endDate}
                          />
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>
                  {/* End date */}
                  <Row>
                    <Col md="12">
                      <FormGroup>
                        <Label>To date:</Label>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <FontAwesomeIcon icon={["far", "calendar-alt"]} />
                            </InputGroupText>
                          </InputGroupAddon>
                          <DatePicker
                            className="form-control"
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            selectsEnd
                            startDate={startDate}
                            endDate={endDate}
                            minDate={startDate}
                          />
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>

                {/* Order Created Date */}
                <Col
                  md="6"
                  lg="6"
                  style={columnStyle}
                  hidden={formField?.isOrderCreatedDateHidden}>
                  <div className="heading-3">Order Created Date</div>
                  <Row>
                    <Col md="12">
                      <FormGroup>
                        <Label>Start date:</Label>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <FontAwesomeIcon icon={["far", "calendar-alt"]} />
                            </InputGroupText>
                          </InputGroupAddon>
                          <DatePicker
                            className="form-control"
                            selected={createdStartDate}
                            onChange={(date) => setCreatedStartDate(date)}
                            selectsStart
                            startDate={createdStartDate}
                            endDate={createdEndDate}
                          />
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>
                  {/* End date */}
                  <Row>
                    <Col md="12">
                      <FormGroup>
                        <Label>End date:</Label>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <FontAwesomeIcon icon={["far", "calendar-alt"]} />
                            </InputGroupText>
                          </InputGroupAddon>
                          <DatePicker
                            className="form-control"
                            selected={createdEndDate}
                            onChange={(date) => setCreatedEndDate(date)}
                            selectsEnd
                            startDate={createdStartDate}
                            endDate={createdEndDate}
                            minDate={createdStartDate}
                          />
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>

                {/* Order Delivery Date */}
                <Col
                  md="6"
                  lg="6"
                  style={columnStyle}
                  hidden={formField?.isOrderDeliveryDateHidden}>
                  <div className="heading-3">Order Delivery Date</div>
                  <Row>
                    <Col md="12">
                      <FormGroup>
                        <Label>Start date:</Label>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <FontAwesomeIcon icon={["far", "calendar-alt"]} />
                            </InputGroupText>
                          </InputGroupAddon>
                          <DatePicker
                            className="form-control"
                            selected={deliveryStartDate}
                            onChange={(date) => setDeliveryStartDate(date)}
                            selectsStart
                            startDate={deliveryStartDate}
                            endDate={deliveryEndDate}
                          />
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>
                  {/* End date */}
                  <Row>
                    <Col md="12">
                      <FormGroup>
                        <Label>End date:</Label>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <FontAwesomeIcon icon={["far", "calendar-alt"]} />
                            </InputGroupText>
                          </InputGroupAddon>
                          <DatePicker
                            className="form-control"
                            selected={deliveryEndDate}
                            onChange={(date) => setDeliveryEndDate(date)}
                            selectsEnd
                            startDate={deliveryStartDate}
                            endDate={deliveryEndDate}
                            minDate={deliveryStartDate}
                          />
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>

                <Col
                  md="6"
                  lg="6"
                  style={columnStyle}
                  hidden={formField?.isPickUpDateHidden}>
                  <div className="heading-3">Pickup Date</div>
                  <Row>
                    <Col md="12">
                      <FormGroup>
                        <Label>Start date:</Label>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <FontAwesomeIcon icon={["far", "calendar-alt"]} />
                            </InputGroupText>
                          </InputGroupAddon>
                          <DatePicker
                            className="form-control"
                            selected={pickupStartDate}
                            onChange={(date) => setPickupStartDate(date)}
                            selectsStart
                            startDate={pickupStartDate}
                            endDate={pickupEndDate}
                          />
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <FormGroup>
                        <Label>End date:</Label>
                        <InputGroup>
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <FontAwesomeIcon icon={["far", "calendar-alt"]} />
                            </InputGroupText>
                          </InputGroupAddon>
                          <DatePicker
                            className="form-control"
                            selected={pickupEndDate}
                            onChange={(date) => setPickupEndDate(date)}
                            selectsEnd
                            startDate={pickupStartDate}
                            endDate={pickupEndDate}
                            minDate={pickupStartDate}
                          />
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
            <Row style={{ padding: 15 }}>
              <Col></Col>
              <Col>
                <Button
                  outline
                  color="link"
                  className="btn-link-dark"
                  onClick={onToggle}>
                  Close
                </Button>
              </Col>
              <Col>
                <Button outline color="primary" onClick={onApplyFilter}>
                  Apply Filter
                </Button>
              </Col>
              <Col></Col>
            </Row>
          </CardBody>
        </Card>
      </Modal>
    </Fragment>
  );
};

const mapDispatchToProps = {
  shipingList,
  getClients,
  get3PLS,
  getServiceTypes,
  getOrderStatuses,
  getHubs,
  getCities,
  getEmployees
};

export default connect(null, mapDispatchToProps)(FilterComponent);
